import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import DetailPageMainView from './DetailPageMainView';
import ButtonList  from '../Button/ButtonList';
import Widget from '../IframeWidget/Widget';
import ListLoad from '../ListLoad/ListLoad';
import OnePage from './OnePage';
import StandardOnePage from './StandardOnePage';
import DetailFormCard from '../DetailFormCard/DetailFormCard';
import { Page, Tabs, Content, Icon, List ,Loading } from '@beisen/chaos-ui';
import BSNav from '../PageNav/Nav';
import OnePageTab from './OnePageTab';
import * as helper from '../util/helper';
import * as uiHelper from '../util/ui';
import * as urlHelper from '../util/url';
import * as htmlHelper from '../util/html';
import { ExtensionWrap, getExtensionCmp } from '../util/extension';
import { isNotEmpty } from '../util/check';
import ApprovalList from '../Approval/ApprovalList';
import { CodeSplit } from 'code-split-component';
import * as pageError from '../util/pageError';
import ErrorPage from '../ErrorPage/ErrorPage';
require('@pbeisen/tita-feed/dist/css/TitaWidget.css');
import transLoader from '@beisen/i18n-translation-loader';
import { unvisibleButton } from '../util/unvisibleButton';
require('./DetailPage.scss');

const defaultTranslation = {
    detail: '详情',
    relative: '相关',
    feed: '协作',
    approval: '审批',
    validateTip: '有必填项未填',
    setError: '配置出错!',
    fetchIndexFail: '获取相关视图失败'
};
class DetailPage extends React.Component {
    constructor(props,context) {
        super(props,context);
        this.handleTouchTap = this.handleTouchTap.bind(this);
        this.touchTapHandler = this.touchTapHandler.bind(this);
        this.handleChangeTab = this.handleChangeTab.bind(this);
        this.changeTabActiveStyle = this.changeTabActiveStyle.bind(this);
        this.setTabKey = this.setTabKey.bind(this);
        this.getWidgetHtmlHeight = this.getWidgetHtmlHeight.bind(this);
        this.shouldTabFixed = this.shouldTabFixed.bind(this);
        this.tabDidMount = this.tabDidMount.bind(this);
        this.tabKey = 'mainView';
        this.extensionNavConfigCallBacks = [];
        this.state = {
            tabKey: this.tabKey
            ,tabPosition: 'relative'
            ,appTitleColor: 'rgba(255,255,255,0)'
            , androidShowTitle: false
        };
        this.buttonList = null;
        this.deviceHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            detail: 'detailPage.detail',
            relative: 'detailPage.relative',
            feed: 'detailPage.feed',
            validateTip: 'tip.validateTip',
            approval: 'detailPage.approval',
            setError: 'tip.setError',
            fetchIndexFail: 'tip.fetchIndexFail'
          }), props.translation);
    }
    // 获取iframe内页面高度
    getWidgetHtmlHeight() {
        const widgetPage = document.getElementById('scrollPage');
        if(window.parent !== window  && widgetPage) {
            if(this.props.detailPage.cmp_data && this.clientHeight != widgetPage.clientHeight) {
                this.clientHeight = widgetPage.clientHeight;
                this.widgetEvent = this.props.query.WidgetEvent;
                // 向父级页面发消息
                window.iTalentSDK.sendMessage({
                        publishEvent: 'IdForApprovalCentreFrame',
                        data: {
                            componentData: { width: '100%', height: this.clientHeight, id: this.widgetEvent, iframeLoaing: false }
                        }
                });
            }
            this.getWidgetHeight = true;
        }
    }
    componentWillReceiveProps(nextProps) {
        //如果页面重新请求数据需要重置tab位置及title样式
        if(this.isTouchButton || (nextProps.detailPage && nextProps.detailPage.isFetching)) {
            this.setState({ tabPosition: 'relative' }, () => {
                this.isTouchButton = false;
                //是否调整scrollPage样式
                this.scrollPageReset = true;
            });
        }
    }
    componentDidMount() {
        this.registerNavEvent();
        this.registerScrollEvent();
        this.getWidgetHtmlHeight();
        this.registerMessage();
        this.setNavDefaultColor();
        //降域
        helper.reducedDomain();
    }

    // 获取导航动画滚动距离
    getAnimationScroll() {
        return this.refs.detailFormCard && ReactDOM.findDOMNode(this.refs.detailFormCard) && ReactDOM.findDOMNode(this.refs.detailFormCard).clientHeight || 0;
    }

    // 获取导航颜色信息
    getNavColor() {
        const extensionConfig = helper.getNavColorExtensionConfig(this.props.detailPage);
        this.extensionConfig = extensionConfig;
        return {
            color: (extensionConfig && extensionConfig.color) || '#ffffff',
            showBorder: false,
            bgColor: (extensionConfig && extensionConfig.bgColor) || '#249ff0',
            titleItem: { color: this.hasFormCard ? 'rgba(255,255,255,0)' : (extensionConfig && extensionConfig.titleColor) || '#ffffff' }
        };
    }

    // 设置导航颜色初始值this.headerColor
    setNavDefaultColor() {
        if(this.props.detailPage.cmp_data && !this.props.detailPage.isFetching) {
            this.getHeaderColor = true;
            this.headerColor = this.getNavColor();
        }
    }

    componentDidUpdate() {
        if(!this.registedScrollEvent) {
            this.registerScrollEvent();
        }
        if(!this.getWidgetHeight) {
            this.getWidgetHtmlHeight();
        }
        if(!this.registerMessageEvent) {
            this.registerMessage();
        }
        if(!this.getHeaderColor) {
            this.setNavDefaultColor();
        }

        if(this.props.isReloading || !this.props.detailPage.cmp_data || this.props.detailPage.isFetching) {
            this.registedScrollEvent = false;
        }
        this.registerNavEvent();
        this.scrollPageReset ? this.scrollHandler(null, this.scrollPage) : null;
        this.scrollPageReset = false;
    }
    componentWillUnmount() {
        this.extensionNavConfigCallBacks = [];
        if(this.scrollPage) {
            this.scrollPage.removeEventListener('scroll',e => {
                this.scrollHandler(e);
            },false);
        }
        if((window.parent == window) && BSGlobal.application === 'ApprovalCentre') {
            window.removeEventListener('message',e => {
                this.message(e);
            },false);
        }
        this.props.actions.clearDetailPageData();
    }


    registerNavEvent() {
        if(this.extensionNavConfigCallBacks) {
            this.extensionNavConfigCallBacks.forEach(item => {
                window.globalEventManager[item.name] = item.handler;
            });
        }
    }
    registerScrollEvent() {
        this.scrollPage = document.getElementById('scrollPage');
        if(this.scrollPage && this.scrollPage != window && BSGlobal.application !== 'ELearning' && BSGlobal.application !== 'Redeem') {
            this.scrollPage.addEventListener('scroll',e => {
                this.refs.standardOnePage && this.refs.standardOnePage.scrollHandler(e);
                this.scrollHandler(e);
                this.timeout && clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                     this.scrollHandler(e);
                    this.changeInterval && clearInterval(this.changeInterval);
                    this.scrollHandler(e);
                },100);
            },false);
            //  this.scrollPage.addEventListener('touchend',(e) => {
            //      this.scrollHandler(e);
            //     this.changeInterval&&clearInterval(this.changeInterval);
            //     this.changeInterval = setInterval(()=>{
            //         this.scrollHandler(e);
            //     },20);
            // },false);
            this.registedScrollEvent = true;
        }
    }
    registerMessage() {
        // iframe父页面监听message
        if((window.parent == window) && BSGlobal.application === 'ApprovalCentre') {
            // 父页面内容置为loading 为了解决审批中心内嵌了iframe时两次loading问题  在iframe内页面没有加载出来之前 都显示父级页面设置的loading
            this.frameParentShouldLoaing = true;
            window.addEventListener('message',e => {
                this.message(e);
            },false);
            this.registerMessageEvent = true;
        }
    }
    message(e) {
        let _data = {};
        // 父级更新iframe高度
        if(e.data && Object.prototype.toString.call(e.data) === '[object Object]') {
            _data = e.data;
        }else {
            try {
                _data  = JSON.parse(e.data || '{}');
            } catch (error) {
                // console.log(error);
            }
        }
        if(_data.publishEvent == 'IdForApprovalCentreFrame' && _data.data.componentData.id) {
            // iframe内页面数据加载完成 将iframe透明度置为1 将父级页面中的loading置为none
            window.iTalentSDK.updateSize('IdForApprovalCentreFrame', '100%', _data.data.componentData.height);
            this.frameParentShouldLoaing = false;
            if(this.refs.detailFrame) {
                this.refs.detailFrame.style.opacity = 1;
            }
            if(this.refs.frameLoad) {
                ReactDOM.findDOMNode(this.refs.frameLoad).style.display = 'none';
            }
        }
        if(_data.publishEvent == 'removeloading' && _data.data.componentData.id) {
            // 当iframe内页面出错 也要将iframe置为none
            if(this.refs.frameLoad) {
                ReactDOM.findDOMNode(this.refs.frameLoad).style.display = 'none';
            }
        }
    }

    // 调用BSNav 方法 来改变导航颜色
    setHeaderColor(config) {
        this.refs.detailNav && this.refs.detailNav.changeHeader({
            color: config.color
            ,bgColor: config.bgColor
            ,titleItem: { color: config.titleItem.color }
            ,showBorder: config.showBorder
        });
    }

    scrollHandler(e, scrollEl) {
        const scrollPage = scrollEl || (e && e.target);
        if(!scrollPage) {
            return false;
        }

        if(this.hasFormCard) {
            if(this.changedTab) {
                scrollPage.scrollTop = 0;
            }
            const animationScroll = this.getAnimationScroll();

            if(scrollPage.scrollTop >= animationScroll) {
                // 导航标题颜色 有扩展颜色走扩展 没有为白色
                const extensionTitleColor = this.extensionConfig && this.extensionConfig.titleColor;
                const titleColor = extensionTitleColor || '#ffffff';
                if(titleColor) {
                    if(this.headerColor.titleItem.color !== titleColor) {
                        this.headerColor.titleItem.color = titleColor;
                        this.setHeaderColor(this.headerColor);
                    }
                }

                if(this.shouldTabFixed() && this.state.tabPosition !== 'fixed') {
                    this.refs.standardOnePage && this.refs.standardOnePage.initHeight && this.refs.standardOnePage.initHeight <= this.deviceHeight ? null : this.setState({ tabPosition: 'fixed' });
                }
            }else if(scrollPage.scrollTop < 40) {
                // 导航标题为透明
                this.changedTab = false;
                if(this.headerColor.titleItem.color !== 'rgba(255,255,255,0)') {
                    this.headerColor.titleItem.color = 'rgba(255,255,255,0)';
                    this.setHeaderColor(this.headerColor);
                }
                if(this.state.tabPosition !== 'relative') {
                    this.setState({ tabPosition: 'relative' });
                }
            }
        }
    }
    shouldTabFixed() {
        const animationScroll = this.getAnimationScroll();
        return (this.scrollPage.scrollHeight - this.scrollPage.clientHeight) > animationScroll;
    }
    setTabKey(key) {
        this.setState({ tabKey: key });
    }
    handleChangeTab(tabKey) {
        // 切换页签时应该清除掉页签的记忆
        sessionStorage.removeItem(window.location.hash);
        this.changedTab = true;
        this.tabKey = tabKey;
        this.setState({ tabKey: tabKey });
    }
    handleTouchTap(e, relateViewObj) {
        sessionStorage.setItem(window.location.hash, 'relativeView');
        let redirectUrl = '';
        let moduleID = '';
        const partId = relateViewObj.cmp_data.viewName;
        if(relateViewObj.sub_cmps[0] && relateViewObj.sub_cmps[0].cmp_type == 'IndexPageModule') {
            const fetchPageModuleParam = {
                viewName: relateViewObj.cmp_data.viewName,
                //不知道对不对。。。
                metaObjName: relateViewObj.cmp_data.metaObjectName,
                formState: 'show',
                id: relateViewObj.cmp_data.dataID,
                detailViewName: relateViewObj.cmp_data.currentDetailPageViewName
                //detailViewName解决相关对象all字段请求参数问题
            };
            const pageContext = {
                'metaObjName': this.props.detailPage.cmp_data.metaObjectName,
                'viewName': this.props.detailPage.cmp_data.viewName,
                'DataId': this.props.detailPage.cmp_data.dataID,
                'currentDetailPageViewName': relateViewObj.cmp_data.currentDetailPageViewName
                //"profilePageViewName": relateViewObj.cmp_data.profilePageViewName
            };
            redirectUrl = `#/IndexPage?activeView=true&pageModule=${JSON.stringify(fetchPageModuleParam)}&pageContext=${JSON.stringify(pageContext)}&pObjectDataID=${this.props.detailPage.cmp_data.dataID}&fromURL=homedetail&partId=${partId}`;
        }else{
            if(this.isRelativeViewIsWidget(relateViewObj)) {
                const widgetObj = relateViewObj.sub_cmps[0];
                if(widgetObj.sub_cmps && widgetObj.sub_cmps[0]) {
                    if(widgetObj.sub_cmps[0].cmp_data && widgetObj.sub_cmps[0].cmp_data.mobileurl.indexOf('#/task_list') >= 0) {
                        helper.pageJump(widgetObj.sub_cmps[0].cmp_data.mobileurl);
                        return false;
                    }
                    //ocean plugin
                    if(widgetObj.sub_cmps[0].cmp_type === 'OceanThemePlugin' || widgetObj.sub_cmps[0].cmp_type === 'OceanPlugin') {
                        //ocean plugin 在壳里独立窗口打开
                        if(window.env.platform.beisenApp || window.env.platform.dingTalk) {
                            helper.openUrlInNewWindow({ title: widgetObj.cmp_data.title },widgetObj.sub_cmps[0].cmp_data.mobileurl || widgetObj.sub_cmps[0].cmp_data.url);
                            return;
                        }
                    }
                    const metaKey = helper.guid();
                    this.props.actions.add_child_to_base_page(widgetObj.sub_cmps[0], metaKey);
                    redirectUrl = '#/BasePage?metaKey=' + metaKey + '&fromURL=homedetail';
                }
            }else {
                let metaKey = '';
                if(relateViewObj.cmp_data.isDefault) {
                    metaKey = relateViewObj.cmp_id;
                    this.props.actions.add_child_to_base_page(relateViewObj,metaKey);
                }else{
                    metaKey = helper.guid();
                };
                //redirectUrl = `#/BasePage?metaKey=${metaKey}&fromURL=homedetail&pObjectDataID=${this.props.detailPage.cmp_data.dataID}&viewName=${relateViewObj.cmp_data.viewName}&metaObjName=${this.props.detailPage.cmp_data.metaObjectName}&showMenu=${this.props.showMenu}&showBack=${this.props.showBack}&viewpath=pageModule&detailViewName=${this.props.detailPage.cmp_data.viewName}&currentDetailPageViewName=${relateViewObj.cmp_data.currentDetailPageViewName}`;
                const queryObject = helper.getQueryObject();
                redirectUrl = `#/BasePage?metaKey=${metaKey}&fromURL=homedetail&pObjectDataID=${this.props.detailPage.cmp_data.dataID}&viewName=${relateViewObj.cmp_data.viewName}&metaObjName=${this.props.detailPage.cmp_data.metaObjectName}&showMenu=${this.props.showMenu}&showBack=${this.props.showBack}&viewpath=pageModule&detailViewName=${  queryObject && queryObject.detailViewName ? queryObject.detailViewName :  this.props.detailPage.cmp_data.viewName}&currentDetailPageViewName=${relateViewObj.cmp_data.currentDetailPageViewName}&mainDetailViewName=${this.props.detailPage.cmp_data.viewName}`;
            }
        }
        if(relateViewObj && relateViewObj.cmp_data && relateViewObj.cmp_data.viewName) {
            moduleID = relateViewObj.cmp_data.viewName;
            redirectUrl = redirectUrl + '&moduleID=' + moduleID;
        }
        helper.pageJump(helper.addQuerytoUrl(redirectUrl,this.props.query));
    }
    getCategoryData() {
        let categoryData = {
            mainViewData: null,
            relativeViewData: [],
            pageName: ''
        };
        if(!this.props.detailPage || !this.props.detailPage.sub_cmps || this.props.detailPage.sub_cmps.length == 0) {
            return categoryData;
        }
        this.props.detailPage.sub_cmps.forEach(item => {
            if(item.cmp_type == 'DetailPageMainView') {
                categoryData.mainViewData = item;
            }else if(item.cmp_type == 'DetailPageRelateView') {
                if(item.cmp_data.visible != false) {
                   categoryData.relativeViewData.push(item);
                }
            } else if (item.cmp_type == 'FeedModule') {
                if (item.sub_cmps && item.sub_cmps[0] && item.sub_cmps[0].cmp_data && item.sub_cmps[0].cmp_data.params === 'hideOperationRecord') {
                    //用于控制协作的操作记录是否显示
                    this.hideOperationRecord = true;
                }
                categoryData.feedData = item;
            }
        });
        const { cmp_data: cmpData = {} } = this.props.detailPage;
        const { title = '' } = cmpData;
        categoryData.pageName = title;
        return categoryData;
    }
    getButtonCmpContext(btnInfo) {
        if(btnInfo.cmp_data && btnInfo.cmp_data.target) {
           return this.findTargetCmpData(this.props.detailPage, btnInfo.cmp_data.target);
        }
        return null;
    }
    //获取相关对象的tab  主对象隐藏时 需要在相关页显示按钮
    renderRelativeView(data) {
        if(data.relativeViewData && data.relativeViewData.length > 0) {
            const relateData = data.relativeViewData.map(item => {
                item.title = item.cmp_data.title;
                item.icon = item.cmp_data.titleIcon;
                item.partCode = item.cmp_data.viewName;
                return item;
            });
            const { translation } = this;
            return (
                <div title={translation.relative} tabKey="relativeView" key='2'>
                    <List cls='relative-container' type='simple' datas={relateData} onTouchTap={this.handleTouchTap} />
                </div>);
        }
        return null;
    }

    getAllRequiredProp(form_sub_cmps,isMultiForm) {
        let validateProps = [];
        for(let i = 0; i < form_sub_cmps.length; i++) {
            for(let j = 0; j < form_sub_cmps[i].sub_cmps.length; j++) {
                if(form_sub_cmps[i].sub_cmps[j].cmp_data.required) {
                    validateProps.push(isMultiForm && form_sub_cmps[i].sub_cmps[j].cmp_data['field_name_for_multi'] ? form_sub_cmps[i].sub_cmps[j].cmp_data['field_name_for_multi'] : form_sub_cmps[i].sub_cmps[j].cmp_data['field_name']);
                }
            }
        }
        return validateProps;
    }
    isValueEmpty(biz_data,prop) {
        if(!biz_data[prop] || typeof biz_data[prop].value === 'undefined' || biz_data[prop].value === null || biz_data[prop].value === '') {
            return true;
        }
        return false;
    }
    beforeStartValidte(allData, btnItem) {
        this.isTouchButton = true;
         //在button真正逻辑调用之前做些验证,目前是处理审批的按钮在调用前验证的逻辑
         if(btnItem.cmp_data && btnItem.cmp_data.params && btnItem.cmp_data.params.indexOf('AC_validate:true') > -1) {
            const formCmpData = allData['Form'];
            const isMultiForm = formCmpData.cmp_data && formCmpData.cmp_data.formViewType == 1;
            const validateProps = this.getAllRequiredProp(formCmpData.sub_cmps,isMultiForm);
            const { translation } = this;
            for(let i = 0; i < validateProps.length; i++) {
                if(this.isValueEmpty(formCmpData.biz_data,validateProps[i])) {
                    this.props.actions.showTip({
                        message: translation.validateTip
                        ,type: 'error'
                    });
                    return false;
                }
            }
         }
        return true;
    }
    getButtonList(allData, mainViewData, pageName) {
        let buttons = allData['ButtonList'].sub_cmps;
        const visibleButton = buttons.filter(button => {
            return !unvisibleButton(button.cmp_data.action);
        });
        if(visibleButton.length <= 0) return null;

        let buttonData = {} ,buttonContext = {};
        if(allData['Form'] && allData['Form'].biz_data) {
            for(let key in allData['Form'].biz_data) {
                buttonData[key] = allData['Form'].biz_data[key].value;
            };
            buttonContext = {
                metaObjName: this.getButtonCmpContext(allData['ButtonList']).metaObjectName || allData['Form'].cmp_data && allData['Form'].cmp_data.metaObjectName,
                viewName: allData['Form'].cmp_data && allData['Form'].cmp_data.viewName,
                version: allData['Form'].verison
            };
        } else {//主对象隐藏 没有form  需要在主对象中获取数据 需优化
            buttonData['id'] = mainViewData.cmp_data.dataID;
            buttonContext = {
                metaObjName: mainViewData.cmp_data.metaObjectName,
                viewName: allData['FormCard'] && allData['FormCard'].cmp_data.viewName || ''
            };
        }
        //格式化审批页中的button
        buttonContext = Object.assign({}, buttonContext,{
            parentId: this.props.query.id,
            parentDataId: this.props.detailPage.cmp_data.dataID,
            pObjectDataID: this.props.detailPage.cmp_data.dataID,
            parentMetaObjName: this.props.query.metaObjName
        });

        return (<ButtonList
                    wrapFooterCls='transition-wrap-detail'
                    {...allData['ButtonList'] }
                    cmpContext={buttonContext}
                    afterAction={this.props.reloadData}
                    data={[buttonData]}
                    ref='footerButton'
                    pageType='detail'
                    queryUrl={this.props.query}
                    actions={this.props.actions}
                    getScrollTop={() => {}}
                    beforeStartValidte={this.beforeStartValidte.bind(this,allData)}
                    pageCode={mainViewData.cmp_data.currentDetailPageViewName}
                    pageName={pageName}
        />);
    }
    //获取feed相关数据
    renderFeed(feedId, title) {
        if(!feedId) {
            return null;
        }
        const feedHeight = this.deviceHeight - (this.hasFormCard ? 110 : 0) - 40 - 44 - 15;//44: tabheight，46:feed输入框height
        const { translation } = this;
        return (
            <div title={title || translation.feed} tabKey="feed" key='3' style={{ 'height': feedHeight + 'px' }}>
                <CodeSplit chunkName="TitaFeed" modules={{ TitaFeed: require('@pbeisen/tita-feed') }} defer={false}>
                   {
                       function render(modules) {
                            const TitaFeed = modules.TitaFeed;
                            return TitaFeed && TitaFeed.SimpleFeed ? <TitaFeed.SimpleFeed feedId={feedId} hideOperation={this.hideOperationRecord} footercls='detailpagefooter' contentHeight={feedHeight - 40} /> : <Loading />;
                       }.bind(this)
                   }
                </CodeSplit>
            </div>
        );
    }
    //获取中间头像数据
    getFormCardInfo(mainViewData) {
        let allData = {};
        let cardInfo = {
            title: '&nbsp;',
            subTitle: '&nbsp;'
        };
        if(!mainViewData) {
            return cardInfo;
        }
        // 应该取实体的icon  不是主对象的icon
        cardInfo['titleIcon'] = this.props.detailPage.cmp_data.titleIcon;
        mainViewData.sub_cmps.forEach(item => {
            allData[item.cmp_type] = item;
        });
        let formBizData = allData['FormCard'] && allData['FormCard'].biz_data[0] || {};
        if(allData['FormCard'] && allData['FormCard'].sub_cmps.length > 0) {
            let formPart = allData['FormCard'].sub_cmps.find(item => {
             return item.cmp_type == 'FormPart';
            });
            const isMultiForm = allData['FormCard'].cmp_data && allData['FormCard'].cmp_data.formViewType == 1;
            if(formPart && formPart.sub_cmps.length > 0) {
                formPart.sub_cmps.forEach((item ,index) => {
                    let data = isMultiForm && item.cmp_data.field_name_for_multi ? formBizData[item.cmp_data.field_name_for_multi] : formBizData[item.cmp_data.field_name] || {};
                    if(index == 0) {
                        cardInfo.title = data ? uiHelper.extractUserName(data.text) : '&nbsp;';
                        if(item.cmp_type == 'BC_UserSelect') {
                            if(data && data.text && data.avatars[data.value]) {
                                cardInfo.user = {};
                                cardInfo.user.Name = uiHelper.extractUserName(data.text);
                                cardInfo.user.Id = data.value;
                                cardInfo.user.avatars = data.avatars[data.value];
                            }
                        }
                    }
                    if(index == 1) {
                        const showLabel = item.cmp_data.IsMobileSubjectShowName;
                        const label = item.cmp_label;
                        const text = data ? uiHelper.extractUserName(data.text) : '';
                        if(showLabel) {
                            cardInfo.subTitle = `${label}: ${text}`;
                        }else {
                            cardInfo.subTitle = data ? text : '&nbsp;';
                        }
                    }
                });
                return cardInfo;
            }
        }else{
            return cardInfo;
        }
    }
    findTargetCmpData(tree,cmp_name) {
        if(tree.cmp_name === cmp_name) {
             return tree.cmp_data;
        }
        if(tree.sub_cmps && tree.sub_cmps.length > 0) {
            for(let i = 0; i < tree.sub_cmps.length; i++) {
                return this.findTargetCmpData(tree.sub_cmps[i], cmp_name);
            }
        }
        return false;
    }
    isRelativeViewIsWidget(relateViewObj) {
       return relateViewObj.sub_cmps &&  relateViewObj.sub_cmps.length > 0
                && (relateViewObj.sub_cmps[0].cmp_type === 'Widget' || relateViewObj.sub_cmps[0].cmp_type === 'WidgetModule');
    }
    isRenderTab(categoryData) {
       if(this.isOnlyRenderOneWidget(categoryData)) {
           return false;
       }
       return categoryData && categoryData.mainViewData && categoryData.relativeViewData && categoryData.relativeViewData.length > 0; //TODO:主对象有可能被隐藏
    }
    isOnlyRenderMainView(categoryData) {
       return categoryData && (!categoryData.relativeViewData || !categoryData.relativeViewData.length);
    }
    isOnlyRenderOneWidget(categoryData) { //当主对象隐藏并且相关对象只有一个Widget时，在当前页面渲染Widge
       return categoryData &&
              categoryData.mainViewData &&
              !categoryData.mainViewData.cmp_data.visible &&
              (categoryData.relativeViewData && categoryData.relativeViewData.length === 1)
              && this.isRelativeViewIsWidget(categoryData.relativeViewData[0]);
    }
    renderButtonList(mainViewData, pageName) { //mainForm button
        let allData = {};
        if(!mainViewData) {
            return null;
        }
        // 当前tab为主对象 或 主对象隐藏并且当前tab为相关时显示按钮
        if((mainViewData.cmp_data && mainViewData.cmp_data.visible == false && this.state.tabKey == 'relativeView') || this.state.tabKey == 'mainView') {
            mainViewData.sub_cmps.forEach(item => {
                allData[item.cmp_type] = item;
            });
            if(!allData['ButtonList'] || allData['ButtonList'].sub_cmps.length == 0) {
                return null;
            }
            return this.getButtonList(allData, mainViewData, pageName);
        }
        return null;
    }
    renderMainView(data) {
        if(data.cmp_data && data.cmp_data.visible == false) {
            return null;
        }else{
            const { translation } = this;
            return (
                <div title={translation.detail} tabKey="mainView" >
                    <ExtensionWrap {...data} componentMap={this.props.componentMap}>
                        <DetailPageMainView {...data} componentMap={this.props.componentMap} formType={'detailForm'} />
                    </ExtensionWrap>
                </div>);
        }
    }
    renderApprovalProcess() {
        if(this.props.query._processInstanceId || this.props.query.processInstanceId) {
            const { translation } = this;
            return (<div title={translation.approval} tabKey="approval" key="4" style={{ paddingTop: '4px' }}>
                        <ApprovalList processInstanceId={this.props.query.processInstanceId} showTip={this.props.actions.showTip} />
                    </div>);
        }
        return null;
    }
    getFeedId(feedData) {
        const query = this.props.location.query;
        if(query._feedId) {
            return query._feedId;
        }
        if(feedData && feedData.sub_cmps && feedData.sub_cmps[0]) {
            return feedData.sub_cmps[0]['cmp_id'];
        }
    }
    getDefaultKey(categoryData) {
        if(categoryData.relativeViewData && categoryData.relativeViewData.length > 0) {
            return 'relativeView';
        }else if(this.getFeedId(categoryData.feedData)) {
            return 'feed';
        }else if(this.props.query.processInstanceId) {
            return 'approval';
        }
        return '';
    }
    rendertBaseDetaileContent(categoryData) {
        let defaultTabkey = 'mainView';
        // 主对象隐藏时
        if(categoryData.mainViewData.cmp_data && categoryData.mainViewData.cmp_data.visible == false) {
            defaultTabkey = this.getDefaultKey(categoryData);
            if(sessionStorage.getItem(window.location.hash) == 'mainView') {
                sessionStorage.setItem(window.location.hash,defaultTabkey);
            }
        }
        if(!defaultTabkey) {
            return null;
        }
        this.tabKey = defaultTabkey;
        let keys = Object.keys(sessionStorage);
        //let vals = Object.values(sessionStorage);
        let vals = [];
        for(let item in sessionStorage) {
            vals.push(sessionStorage[item]);
        }
        let val = '';
        keys.forEach((item,index) => {
            if(item === window.location.hash) {
                val = vals[index];
            }
        });
        const showCard = this.props.location.query.showCard;
        if((showCard == 'false' || window.top != window.self) && !(this.props.location.query.hasOwnProperty('_processInstanceId') || this.props.location.query.hasOwnProperty('_taskObjectId') || this.props.location.query.hasOwnProperty('_approvalObjectId'))) {
           return (<Content>
                        <ExtensionWrap {...categoryData.mainViewData} componentMap={this.props.componentMap}>
                            <DetailPageMainView {...categoryData.mainViewData} componentMap={this.props.componentMap} formType={'detailForm'} />
                        </ExtensionWrap>
                    </Content>
            );
        }
        return (<Tabs defaultKey={val ? val : defaultTabkey}
                     ref="detailTabs" changeTab={this.handleChangeTab}
                     setTabKey={this.setTabKey}
                     shouldFixed={!this.hasFormCard}
                     navHeight={this.navHeight}
                     tabPosition={this.state.tabPosition}
                     restriction={1}>
                    {this.renderMainView(categoryData.mainViewData)}
                    {this.renderRelativeView(categoryData)}
                    {this.renderFeed(this.getFeedId(categoryData.feedData))}
                    {this.renderApprovalProcess()}
        </Tabs>);
    }
    renderWidgetDetailContent(categoryData) {
        const { translation } = this;
        if(categoryData.relativeViewData.length > 0) {
            let url = categoryData.relativeViewData[0].sub_cmps && categoryData.relativeViewData[0].sub_cmps[0]
                    && categoryData.relativeViewData[0].sub_cmps[0].sub_cmps && categoryData.relativeViewData[0].sub_cmps[0].sub_cmps[0]
                    && categoryData.relativeViewData[0].sub_cmps[0].sub_cmps[0].cmp_data.url;
            const widgetHeight = this.renderButtonList(categoryData.mainViewData) ? window.innerHeight - 100 : window.innerHeight - 44;
            if(this.props.detailPage.cmp_data.isAttendanceBusiness) {
                if(url.indexOf('showCard') > -1) {
                    url = url.replace(/showCard=false/gim,'showCard=true');
                }else {
                    url = url + '&showCard=true';
                }
                url = urlHelper.keepHttpsProtocolSame(url);
                return (<div  style={{ width: window.innerWidth }} className="iframeWidget"  ref="detailFrame" >
                    <Widget cmp_data={{ url: url, mobileurl: url }} cmp_id={categoryData.relativeViewData[0].sub_cmps[0].sub_cmps[0].cmp_id} height={widgetHeight} isAttendanceBusiness={true} resizeHeight={this.props.detailPage.cmp_data.isAttendanceBusiness} id="IdForApprovalCentreFrame" />
                    {this.renderApprovalProcess()}
                </div>);
            };
            url = urlHelper.keepHttpsProtocolSame(url);
            return  (<Tabs defaultKey={sessionStorage.getItem('tabkey') ? sessionStorage.getItem('tabkey') : 'mainView'} ref="detailTabs" shouldFixed={!this.hasFormCard} navHeight={this.navHeight} changeTab={this.handleChangeTab} tabPosition={this.state.tabPosition} >
                        <div title={translation.detail} tabKey="mainView" >
                            <Widget cmp_data={{ url: url, mobileurl: url }} cmp_id={categoryData.relativeViewData[0].sub_cmps[0].sub_cmps[0].cmp_id} height={widgetHeight} resizeHeight={this.props.detailPage.cmp_data.isAttendanceBusiness} id="IdForApprovalCentreFrame" />
                        </div>
                        {this.renderFeed(this.getFeedId(categoryData.feedData))}
                        {this.renderApprovalProcess()}
        </Tabs>);
        }
        return <Content>{translation.setError}</Content>;
    }

    getTitle(categoryData) {
        const formCardInfo = this.getFormCardInfo(categoryData.mainViewData);
        const hasFormCard = this.shouldHaveFormCard(formCardInfo);
        const configNavigation = this.props.detailPage.cmp_data.configNavigation;
        if(configNavigation && configNavigation.titleItem && configNavigation.titleItem.text) {
            return htmlHelper.decode(configNavigation.titleItem.text);
        }
        return hasFormCard ? formCardInfo && htmlHelper.decode(formCardInfo.title) : htmlHelper.decode(categoryData.mainViewData.cmp_data.title);
    }

    getDetailNav(categoryData,hasRightIcon) {
        this.detailNav = ReactDOM.findDOMNode(this.refs.detailNav);
        this.navHeight = this.detailNav && this.detailNav.clientHeight;
        this.navTitle = this.detailNav && this.detailNav.getElementsByClassName('nav-center')[0];
        const leftCb = helper.getNavLeftExtension(this.props.detailPage);

        return (<BSNav ref="detailNav" cls='fixed-header'
                        handleBack={leftCb && leftCb.back}
                        handleClose={leftCb && leftCb.close}
                        hasRightIcon={hasRightIcon}
                        isDetail={true}
                        headerColor={this.headerColor || this.getNavColor()}
                        title={this.getTitle(categoryData)}>
                    <span role='right'>{helper.genRightItemByExtensionNavConfig(this.props.detailPage,'detail') || <br />} </span>
                </BSNav>);
    }
    noFormCardList() {
        // 以下情况不渲染自己页面的formcard
        // 1.嵌了假勤的审批 2.嵌在审批中除了假勤的应用
        if(this.props.detailPage.cmp_data.isAttendanceBusiness || (['TenantBase','Attendance'].indexOf(BSGlobal.application) < 0 && window.parent !== window)) {
            return true;
        }
        return false;
    }
    getDetailCard(categoryData) {
        if(this.noFormCardList()) {
            return null;
        }
        if(categoryData.mainViewData && this.hasFormCard) {
            const mainViewDataSubCmps = categoryData.mainViewData.sub_cmps || [];
            const formCardData = mainViewDataSubCmps.find(item => {
                return item.cmp_type == 'FormCard';
            });
            const formCardInfo = this.getFormCardInfo(categoryData.mainViewData);
            const DestCmp = getExtensionCmp(formCardData) || DetailFormCard;
            if(getExtensionCmp(formCardData)) {
                return <DestCmp actions={this.props.actions} {...formCardData} ref="detailFormCard" />;
            }
            return <DetailFormCard {...formCardInfo} ref="detailFormCard" />;
        }
        return null;
    }
    getDetailContent(categoryData, hasRightIcon) {
        if(this.isOnePage) {
            const hideModule = ['Form'];
            const pluginModule = ['DashBoardPlugin','OceanThemePlugin','OceanPlugin', 'CustomWidget'];
            if(categoryData.relativeViewData) {
                categoryData.relativeViewData.forEach(item => {
                    let temp = item.sub_cmps[0];
                    let widgetSub = temp['sub_cmps'][0];
                    if(temp && widgetSub && temp.cmp_type === 'WidgetModule' && pluginModule.includes(widgetSub.cmp_type)) {
                        item.cmp_data.isPlugin = true;
                        return;
                    }
                    if(temp && hideModule.includes(temp.cmp_type)) {
                        item.cmp_data.visible = false;
                    }
                });
            }
            const formCardInfo = this.getFormCardInfo(categoryData.mainViewData);
            if(BSGlobal.application === 'ELearning') {
                 return (
                    <OnePage
                        detailPage={this.props.detailPage}
                        onePageData={categoryData}
                        query={this.props.query}
                        componentMap={this.props.componentMap}
                        actions={this.props.actions}
                    />
                );
            }
            return (
                <StandardOnePage
                    ref='standardOnePage'
                    hideOperationRecord={this.hideOperationRecord}
                    tabLabArr={this.tabLabArr}
                    hasRightIcon={hasRightIcon}
                    changeTabActiveStyle={this.changeTabActiveStyle}
                    isShowButtonList={this.buttonList ? true : false}
                    isShowTab={(this.state.tabPosition == 'fixed' || !this.hasFormCard) && this.tabLabArr.length > 1}
                    hasFormCard={this.hasFormCard}
                    formCardInfo={formCardInfo}
                    formCardHeight={this.refs.detailFormCard && ReactDOM.findDOMNode(this.refs.detailFormCard).clientHeight || 0}
                    detailPage={this.props.detailPage}
                    onePageData={categoryData}
                    query={this.props.query}
                    componentMap={this.props.componentMap}
                    actions={this.props.actions}
                    handlerRelativeJump={this.handleTouchTap}
                    getWidgetHtmlHeight={this.getWidgetHtmlHeight}
                    translation={this.translation}

                />
            );
        }else if(categoryData.mainViewData && !categoryData.mainViewData.cmp_data.visible && BSGlobal.application === 'ApprovalCentre') {
            return this.renderWidgetDetailContent(categoryData);
        }else if(categoryData.mainViewData) {
            return this.rendertBaseDetaileContent(categoryData);
        }
    }
    getErrorPage() {
        return pageError.errorPage(this.props,this.props.detailPage.errors.status);
    }
    appliactionInOnePageWhiteList() {
        const wl = ['TenantBase','Attendance','ELearning','BeisenCloudDemo','TargetManagement','IDP','BeisenCloudSteppeApp','BeisenCloudStepAAA'];
        return wl.indexOf(BSGlobal.application) > -1;
    }
    shouldHaveFormCard(formCardInfo = { title: '',subTitle: '' }) {
        const title = formCardInfo.title.replace(/&nbsp;/g,'');
        const subTitle = formCardInfo.subTitle.replace(/&nbsp;/g,'');
        return formCardInfo && !(title == '' && subTitle == '');
    }
    changeTabActiveStyle(index) {
        this.refs.onePageTab && this.refs.onePageTab.scrollActiveStyle(index);
    }
    touchTapHandler(index) {
        this.refs.standardOnePage && this.refs.standardOnePage.touchTapHandler(index);
    }
    tabDidMount() {
        this.refs.standardOnePage && this.refs.standardOnePage.removeTabFun();
    }

    getOnePageRelativeView(relativeViewData) {
        const showModule = ['DashBoardPlugin','OceanThemePlugin','OceanPlugin', 'CustomWidget'];
        return relativeViewData.filter(item => {
                const temp = item.sub_cmps[0];
                const widgetSub = temp['sub_cmps'][0];
                const tableList = temp && (temp.cmp_type === 'TableList');
                const pluginModule = temp && widgetSub && temp.cmp_type === 'WidgetModule' && showModule.includes(widgetSub.cmp_type);
                return tableList || pluginModule;
        });
    }
    renderTab(categoryData) {
        return (<div id='onpagetab'>
            <OnePageTab ref='onePageTab' tabLabArr={this.tabLabArr} touchTapHandler={this.touchTapHandler} tabDidMount={this.tabDidMount} />
        </div>);
    }
    render() {
        const { translation } = this;
        const categoryData = this.getCategoryData();
        const isWidgetInApprovalcentre = window.parent !== window;

        let errorInfo = helper.getErrorInfo(this.props.detailPage.errors);
        if(errorInfo) {
            if(window.parent !== window) {
                // iframe内页面无导航  tip top值改为0
               if(document.getElementById('superTip')) {
                   const errorTip = document.getElementById('superTip');
                   if(errorTip.getElementsByClassName('ui-prompts')[0]) {
                       const prompts = errorTip.getElementsByClassName('ui-prompts')[0];
                       prompts.style.top = '0px';
                   }
               }
               if(document.getElementById('idforFrameNav')) {
                   const detailNav = document.getElementById('idforFrameNav');
                   detailNav.style.display = 'none';
               }
               this.widgetEvent = this.props.query.WidgetEvent;
               // 嵌套在页面里的页面发生错误 向父级页面发消息 关闭loading
               window.iTalentSDK.sendMessage({
                   publishEvent: 'removeloading',
                   data: {
                       componentData: { id: this.widgetEvent, iframeLoaing: false }
                   }
               });
           }
           return(
                <Page cls="detail-page">
                    <BSNav ref="indexNav" noSysClose />
                    <Content style={{ 'background': '#ffffff' }}>
                        <ErrorPage {...errorInfo} />
                    </Content>
                </Page>
           );
        }

        if(!this.props.detailPage.cmp_data || this.props.detailPage.isFetching) {
            return (<Page cls="detail-page">
                        {isWidgetInApprovalcentre ? null : <BSNav cls="nav-loading" ref="detailNav" noSysClose />}
                        <Content><ListLoad detail={true} /></Content>
                    </Page>);
        }
        const renderType = this.props.detailPage.cmp_data.renderType;
        const formCardInfo = this.getFormCardInfo(categoryData.mainViewData);
        this.hasFormCard = this.shouldHaveFormCard(formCardInfo);
        this.isOnePage = renderType != 'TabPage' && this.appliactionInOnePageWhiteList();
        this.buttonList =  this.renderButtonList(categoryData.mainViewData, categoryData.pageName);
        const hasRightIcon = isNotEmpty(this.props.detailPage,['cmp_data','configNavigation','rightItem']);
        const cls = classNames('detail-page tab-page'
                                            ,{ 'hasCard': this.hasFormCard && BSGlobal.application !== 'ELearning' && !this.noFormCardList() }
                                            ,{ 'onepage': this.isOnePage }
                                            ,{ 'isElearning': BSGlobal.application === 'ELearning' }
                                            ,{ 'isWidgetInApprovalcentre': isWidgetInApprovalcentre }
                                            ,{ 'hasBtn': this.buttonList ? true : false }
                                            ,{ 'noCardWidget': this.noFormCardList() }
                                            ,{ 'isInWebDetail': !window.env.platform.beisenApp }
                                            ,{ 'isAndroid': window.env.platform.android }
                                            ,{ 'isCustomApp': window.env.platform.weixin || window.env.platform.dingTalk }
                                            ,{ 'hasRightIcon': hasRightIcon }
                                        );
        this.tabLabArr = [];
        if(this.isOnePage) {
            if(categoryData.mainViewData.cmp_data.visible) {
                this.tabLabArr.push({ value: translation.detail,key: 'detail' });
            }
            if(categoryData.relativeViewData && categoryData.relativeViewData.length > 0) {
                const onepageRelative = this.getOnePageRelativeView(categoryData.relativeViewData);
                if(onepageRelative.length > 0) {
                    this.tabLabArr.push({ value: translation.relative,key: 'relative' });
                }
            }
            if(helper.getQueryObject().processInstanceId) {
                this.tabLabArr.push({ value: translation.approval,key: 'approval' });
            }
            if(this.getFeedId(categoryData.feedData)) {
                this.tabLabArr.push({ value: translation.feed,key: 'feed' });
            }
        }
        return (<Page cls={cls}>
                    {this.frameParentShouldLoaing && this.props.detailPage.cmp_data.isAttendanceBusiness ? <ListLoad detail={true} ref="frameLoad" style={{ position: 'absolute', zIndex: '2', width: window.innerWidth, height: '100%' }} /> : null}
                    {this.getDetailNav(categoryData,hasRightIcon)}
                    {(this.state.tabPosition == 'fixed' || !this.hasFormCard) && this.tabLabArr.length > 1 && this.isOnePage ? this.renderTab(categoryData) : null}
                    {<div className='detail-scroll-content' id="scrollPage" ref="datailScrollContent" style={{ paddingTop: isWidgetInApprovalcentre ? '0px' : this.navHeight }}>
                        {this.getDetailCard(categoryData)}
                        {this.getDetailContent(categoryData,hasRightIcon)}
                    </div>}
                    {this.buttonList}
                    {this.isOnePage ? <div className="transformForOnePage" /> : null}
              </Page>);
    }
}
export default DetailPage;



// WEBPACK FOOTER //
// ./src/components/DetailPage/DetailPage.js